import type { CreateOrderRequestBody } from "@paypal/paypal-js";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

/*
return actions.order.create({
            purchase_units: [
            {
                reference_id: "PUHF",
                description: "Some description",

                custom_id: "Something7364",
                soft_descriptor: "Great description 1",
                amount: {
                    currency_code: "EUR",
                    value: "200.00",
                    breakdown: {
                        item_total: {
                            currency_code: "EUR",
                            value: "200.00"
                        }
                    }
                },
                items: [
                    {
                        name: "Item 1",
                        description: "The best item ever",
                        sku: "xyz-2654",
                        unit_amount: {
                            currency_code: "EUR",
                            value: "100.00"
                        },
                        quantity: "1"
                    },
                    {
                        name: "Item 2",
                        description: "Not bad too",
                        sku: "zdc-3942",
                        unit_amount: {
                            currency_code: "EUR",
                            value: "50.00"
                        },
                        quantity: "2"
                    }
                ],

            }
        ]
    });
*/


export interface TicketState {
  order: CreateOrderRequestBody
  orderId: string
  status: 'idle' | 'pending' | 'created' | 'paid' | 'failed'
  error: null | string
}

const initialState: TicketState = {} as TicketState;

export const createOrder = createAsyncThunk<string, CreateOrderRequestBody, { rejectValue: { readonly errorMessage: string } }>(
  'order/create',

  async (arg, thunkAPI) => {

    if (!arg) {
      throw new Error(`No paypal order in request.`);
    }

    return await fetch(
      '/api/order/',
      {
        method: 'POST',
        body: JSON.stringify(arg)
      })

      .then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch((error) => {
        console.error(error);
        return thunkAPI.rejectWithValue({ errorMessage: error.message });
      });
  }
);

export const captureOrder = createAsyncThunk<void, string, { rejectValue: { readonly errorMessage: string, readonly id: string } }>(
  'order/capture',

  async (arg, thunkAPI) => {

    if (!arg) {
      throw new Error(`No orderId in request.`);
    }

    return await fetch(
      '/api/faqs/',
      {
        method: 'POST',
        body: JSON.stringify(arg)
      })

      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch((error) => {
        console.error(error);
        return thunkAPI.rejectWithValue({ errorMessage: error.message, id: arg });
      });
  }
);


export const ticketSlice = createSlice({
    name: 'ticketstate', // same as the reference in store.ts
    initialState,
    reducers: {
        resetState: () => initialState,
        setPaidFor: (state) => {
          state.status = 'paid';
        },
        setError: (state, action) => {
          state.error = action.payload;
        },
    },  
    extraReducers: (builder) => {
      builder
      .addCase(createOrder.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        resetState();
        state.status = 'created';
      })
      .addCase(createOrder.rejected, (state, action) => {
        console.log(action.payload?.errorMessage)
        if (action.payload !== undefined) {
            state.error = action.payload.errorMessage;
        }
        state.status = 'failed';
      })
      .addCase(captureOrder.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(captureOrder.fulfilled, (state, action) => {
        resetState();
        state.status = 'paid';
      })
      .addCase(captureOrder.rejected, (state, action) => {
        console.log(action.payload?.errorMessage)
        if (action.payload !== undefined) {
            state.error = action.payload.errorMessage;
        }
        state.status = 'failed';
      })
      ;
    },
      
  
});

export const {resetState,setPaidFor,setError} = ticketSlice.actions


export default ticketSlice.reducer;